import type { UIOrchestrationCarrierSummary } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const carrierSummaries = {
  search: {
    queryKey: 'orchestration-service/carrier-summaries',
    configurationType: 'default' as const,
    fn: async (partnerId: string) => {
      const { data } = await GatewayAxiosClient.get<UIOrchestrationCarrierSummary[]>(
        `/ui-orchestration-proxy/api/v1/carrier/partner/${partnerId}`,
      );

      return data;
    },
  },
};
